import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';
import { Order } from '../../entities/orders/orders.types';
import { AddIngredientPayload } from '../recipes/appRecipes.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/appOrders');

export const addIngredientInOrder = actionCreator<AddIngredientPayload>('ADD_INGREDIENT_IN_ORDER');
export const setOrderIsEdit = actionCreator<boolean>('SET_ORDER_IS_EDIT');
export const setIngredientIdToAddInOrder = actionCreator<string | null>('SET_INGREDIENT_ID_TO_ADD_IN_ORDER');
export const editOrder = actionCreator.async<{ isEdit: boolean }, any>('EDIT_ORDER');
export const removeIngredientFromOrder = actionCreator<string>('REMOVE_INGREDIENT_FROM_ORDER');
export const changeIngredientNote = actionCreator<{ uiId: string; notes: string }>('CHANGE_INGREDIENT_NOTE');
export const resetOrderIngredients = actionCreator('RESET_ORDER_INGREDIENTS');
export const deleteOrder = actionCreator.async<{ orderId: string }, any>('DELETE_ORDER');
export const createNewDelivery = actionCreator.async<{ noSave?: boolean; newPriceDateIngredients?: Set<string> }, any>(
  'CREATE_NEW_DELIVERY',
);
export const setDeliveryPreview = actionCreator<Order>('SET_DELIVERY_PREVIEW');
export const getIngredientCurrentPriceDate = actionCreator.async<
  { ingredientId: string; actualPriceDateField: string },
  {}
>('GET_INGREDIENT_CURRENT_PRICE_DATE');
